<div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
</div>
<div class="container canvas-page" [class.ArabicFont]="globalService.isRTL == true"
  *ngIf="!isLoading">
  <br>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!isLoading">
    <div class="card SmallForm RegularForm rounded canvas-panel" *ngIf="!isLoading">
      <div class="card-body MyCardBody rounded-bottom p-0">
        <div class="accordion" id="MainMenu" [class.SmallArabicFont]="globalService.isRTL == true">
          <div class="card">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Membership" aria-expanded="false" aria-controls="Membership">
                  {{ globalService.Get("MEMBERSHIP") }} <i class="fas fa-user ml-2"></i>
                  <span class="badge badge-danger mx-2 pt-2"
                    *ngIf="identityService.hasMembershipRequests() && identityService.hasBirthday() && (requests + birthdayCount > 0)">{{
                    requests + birthdayCount }}</span>
                  <span class="badge badge-danger mx-2 pt-2"
                    *ngIf="identityService.hasMembershipRequests() && (identityService.hasBirthday() == false) && (requests > 0)">{{
                    requests }}</span>
                  <span class="badge badge-danger mx-2 pt-2"
                    *ngIf="(identityService.hasMembershipRequests() == false) && (identityService.hasBirthday()) && (birthdayCount > 0)">{{
                    birthdayCount }}</span>
                </div>
              </h2>
            </div>
            <div id="Membership" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div *ngIf="
                identityService.hasDirectory()
              ">
                  <div class="styledbutton" (click)="CallViewAccount()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("DIRECTORY") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                requests > 0 &&
                (identityService.hasMembershipRequests())
              ">
                  <div class="styledbutton" (click)="CallMembership()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MEMBERSHIP_REQUESTS") }}
                      <span class="badge badge-danger pt-2">{{ requests }}</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="identityService.hasBirthday()                
              ">
                  <div class="styledbutton" (click)="CallBirthday()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("BIRTHDAY") }}
                      <span class="badge badge-danger pt-2" *ngIf="birthdayCount > 0">{{
                        birthdayCount
                        }}</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasProfileViewer() || identityService.hasCommunication()
              ">
                  <!-- <div class="card"> -->
                  <div class="card-body p-0">
                    <div class="styledbutton collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                      data-target="#Communication" aria-expanded="false" aria-controls="Communication">
                      <span [class.SmallArabicFont]="globalService.isRTL == true">
                        {{ globalService.Get("COMMUNICATION") }}
                      </span>
                    </div>
                  </div>
                  <div id="Communication" class="collapse" data-parent="#Communication">
                    <div class="card-body p-0">
                      <div *ngIf="
                        identityService.hasProfileViewer() || identityService.hasCommunication()
              ">
                        <div class="styledDeepbutton" (click)="CallSelectiveCommunication()">
                          <span [class.SmallArabicFont]="globalService.isRTL == true">
                            {{ globalService.Get("SELECTIVE") }}
                          </span>
                        </div>
                        <div class="styledDeepbutton" (click)="CallCommunication()">
                          <span [class.SmallArabicFont]="globalService.isRTL == true">
                            {{ globalService.Get("COLLECTIVE") }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
                <div *ngIf="identityService.hasNotes()                
                ">
                  <div class="styledbutton" (click)="CallNotes()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("NOTES") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMyProfile()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MYPROFILE") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Schedules" aria-expanded="false" aria-controls="Schedules">
                  {{ globalService.Get("SERVICES") }} <i class="fas fa-calendar ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Schedules" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>
                  <div class="styledbutton" (click)="CallCalendar()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CALENDAR") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMyRegistrations()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MYREGISTRATIONS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                    identityService.hasEvents()
              ">
                  <div class="styledbutton" (click)="CallEventReport()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MANAGE_EVENTS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasAttendance()
              ">
                  <div class="styledbutton" (click)="CallAttendance()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("ATTENDANCE") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="identityService.hasServiceSetup()                
                ">
                  <div class="styledbutton" (click)="CallServiceSetup()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("SERVICE_SETUP") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Groups" aria-expanded="false" aria-controls="Groups">
                  {{ globalService.Get("GROUPS") }} <i class="fas fa-users ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Groups" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div *ngIf="depCount > 0 && identityService.hasGroupAdmin()">
                  <div class="styledbutton" (click)="CallDepartment()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("DEPARTMENTS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="supCount > 0 && identityService.hasGroupAdmin()">
                  <div class="styledbutton" (click)="CallSuperGroups()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("SUPERGROUPS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="identityService.hasGroupAdmin()">
                  <div class="styledbutton" (click)="CallGroups()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("GROUP_SETUP") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMyGroups()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MY_GROUPS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="grpRequests > 0 && identityService.hasGroupAdmin()">
                  <div class="styledbutton" (click)="CallGroupRequests()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("GROUP_REQUESTS") }}
                      <span class="badge badge-danger pt-2">{{ grpRequests }}</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="identityService.hasGroupAdmin()">
                  <div class="styledbutton" (click)="callPointSystem()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("POINT_SYSTEM") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse" data-target="#Forms"
                  aria-expanded="false" aria-controls="Forms">
                  {{ globalService.Get("FORMS") }} <i class="fas fa-edit ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Forms" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div *ngIf=" 
                identityService.hasFormAdmin()
              ">
                  <div class="styledbutton" (click)="CallFormBuilder()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("FORM_BUILD") }}
                    </span>
                  </div>
                </div>
                <div *ngIf=" 
                identityService.hasFormsView() || identityService.hasFormEditor()
              ">
                  <div class="styledbutton" (click)="CallFormData()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("FORM_SUBMISSIONS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMyForms()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MY_FORMS") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="identityService.hasTaskAssignment()">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Followups" aria-expanded="false" aria-controls="Followups" disabled="true">
                  {{ globalService.Get("TASKS") }} <i class="fas fa-list ml-2"></i><span
                    class="badge badge-danger mx-2 pt-2" *ngIf="taskCount + taskNotificationCount > 0">{{
                    taskCount + taskNotificationCount
                    }}</span>
                </div>
              </h2>
            </div>
            <div id="Followups" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>
                  <div class="styledbutton" (click)="CallFollowup()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MANAGE_TASKS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMyTasks()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MY_TASKS") }}
                      <span class="badge badge-danger pt-2" *ngIf="taskCount > 0">{{
                        taskCount
                        }}</span>
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallNotifications()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("NOTIFICATIONS") }}
                      <span class="badge badge-danger pt-2" *ngIf="taskNotificationCount > 0">{{
                        taskNotificationCount
                        }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="identityService.hasTaskAssignment()">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Volunteering" aria-expanded="false" aria-controls="Volunteering">
                  {{ globalService.Get("VOLUNTEERING") }} <i class="fas fa-bell ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Volunteering" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>
                  <div class="styledbutton" (click)="CallVolunteering()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("SETUP") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="1==2">
                  <div class="styledbutton">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CALENDAR") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="1==2">
                  <div class="styledbutton">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MYACTIVITIES") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="1==2">
                  <div class="styledbutton">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("AVAILABILITY") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="card" *ngIf="donationLink != null && donationLink != ''">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Donate" aria-expanded="false" aria-controls="Donate">
                  {{ globalService.Get("DOCUMENTS") }} <i class="fas fa-file-pdf ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Donate" class="collapse" data-parent="#MainMenu">
            </div>
          </div> -->
          <div class="card" *ngIf="identityService.hasBirthday() || identityService.hasNotes() || identityService.hasEvents() || identityService.hasAttendance() ||
            identityService.hasProfileViewer() || identityService.hasGiving()">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Reports" aria-expanded="false" aria-controls="Reports">
                  {{ globalService.Get("REPORTS") }} <i class="fas fa-chart-line ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Reports" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div *ngIf="
                identityService.hasProfileViewer()
              ">
                  <div class="styledbutton" (click)="CallMapDistribution()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MAP_DISTRIBUTION") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasBirthday()
              ">
                  <div class="styledbutton" (click)="CallBirthday()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("BIRTHDAY") }}
                      <span class="badge badge-danger pt-2" *ngIf="birthdayCount > 0">{{
                        birthdayCount
                        }}</span>
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasNotes()
              ">
                  <div class="styledbutton" (click)="CallNotes()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("NOTES") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasEvents()
              ">
                  <div class="styledbutton" (click)="CallEventReport()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("MANAGE_EVENTS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasAttendance()
              ">
                  <div class="styledbutton" (click)="CallAttendance()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("ATTENDANCE") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasAttendance()
              ">
                  <div class="styledbutton" (click)="CallActivityChart()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("ACTIVITY_CHART") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasGiving()  
              ">
                  <div class="styledbutton" (click)="CallDonationReport()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("GIVING_REPORT") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasProfileViewer()
              ">
                  <div class="styledbutton" (click)="CallDemographicsChart()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("DEMOGRAPHICS") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="card" *ngIf="identityService.hasCMSAdministrator() && cmsModule == true">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse" data-target="#CMS"
                  aria-expanded="false" aria-controls="CMS">
                  {{ globalService.Get("CONTENT_MANAGEMENT") }} <i class="fas fa-table ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="CMS" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>

                  <div class="styledbutton" (click)="CallCMS()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CONFIGURE") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="card" *ngIf="identityService.hasAdmin()">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#Settingss" aria-expanded="false" aria-controls="Settingss">
                  {{ globalService.Get("SYSTEM_SETTINGS") }} <i class="fas fa-wrench ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="Settingss" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>
                  <div class="styledbutton" (click)="CallServiceGroup()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CATEGORIES") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallServiceVenue()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("LOCATIONS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallRegistrationGroup()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("POLICIES") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallTags()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("TAGS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallLinks()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("LINKS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallMemberPermission()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("PERMISSIONS") }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="styledbutton" (click)="CallImport()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("DATA_IMPORT") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasAdmin() 
              ">
                  <div class="styledbutton" (click)="CallDataDownload()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("DATA_EXPORT") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasGiving()
              ">
                  <div class="styledbutton" (click)="CallFundTypes()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("FUND_TYPES") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
  identityService.hasAdmin()
">
                  <div class="styledbutton" (click)="CallPaymentAdapters()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("PAYMENT_ADAPTERS") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="
                identityService.hasAdmin()
              ">
                  <div class="styledbutton" (click)="CallShowSubscription()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("SUBSCRIPTION") }}
                    </span>
                  </div>
                </div>
                <div *ngIf="identityService.hasAdmin()">
                  <div class="styledbutton" (click)="CallMyChurch()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CHURCH_SETUP") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="identityService.hasSuperAdmin()">
            <div class="card-header accordion-button">
              <h2 class="mb-0">
                <div class="collapsed accordion-button-text text-center p-4" data-toggle="collapse"
                  data-target="#SuperAdmin" aria-expanded="false" aria-controls="SuperAdmin">
                  {{ globalService.Get("SUPER_ADMIN") }} <i class="fas fa-cog ml-2"></i>
                </div>
              </h2>
            </div>
            <div id="SuperAdmin" class="collapse" data-parent="#MainMenu">
              <div class="card-body p-0">
                <div>
                  <div class="styledbutton" (click)="CallChurches()">
                    <span [class.SmallArabicFont]="globalService.isRTL == true">
                      {{ globalService.Get("CHURCHES") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
